
import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { create } from 'kts-scaffold-framework/utils/form';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { RollTypeInvoicePlate, UsedCarInvoicePlate } from 'kts-invoice-plate';
import Template from 'kts-platform-frame/display/components/InvoiceTemplate';
import moment from 'moment';
import { Modal, Tooltip } from 'antd';
import { getCityName } from 'src/utils';
import { Field } from 'kts-scaffold-framework/utils/doc';

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    templateType: string;
    templateData: any;
    template: boolean;
    closeTemplate: () => void;
}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {
    /** 构造函数 */
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    usedCarInvoiceData = (data) => {
        return {
            typeText: '二手车销售统一发票',
            invoiceCode: data.invoiceCode,
            invoiceNum: data.invoiceNumber,
            invoiceDate: data.invoiceDate
        };
    }
    usedCarInvoiceDataColumns = () => {
        return [
            {
                title: '开票日期：',
                dataIndex: 'invoiceDate',
                alignText: 'flex-start' as ('center' | 'flex-end' | 'flex-start'),
                render: (text) => {
                    return text ? moment.unix(text / 1000)
                        .format('YYYY-MM-DD') : '';
                }
            },
            {
                title: '发票号码：',
                dataIndex: 'invoiceNum',
                alignText: 'flex-start' as ('center' | 'flex-end' | 'flex-start'),
                render: (text) => {
                    return text;
                }
            },
            {
                title: (<div style={{ whiteSpace: "nowrap" }}>发票代码:</div>),
                dataIndex: 'invoiceCode',
                alignText: 'flex-start' as ('center' | 'flex-end' | 'flex-start'),
                render: (text) => {
                    return text;
                }
            },
        ];
    }
    usedCarContentData = (data) => {
        return {
            machineCode: data.invoiceCode, // '机打代码',
            machineNum: data.invoiceNumber, // '机打号码',
            machineNumber: data.machineCode, // '机器编号',
            taxControlCode: '', // '税控码',
            buyerName: data.buyerUnitOrIndividual, // '买方单位/个人',
            buyerNumber: data.buyerUnitCodeOrIdNo, // '买方单位代码/身份证号码',
            buyerAddress: data.buyerUnitOrIndividualAddress, // '买方单位/个人住址',
            buyerPhone: data.buyerPhone, // '买方电话',
            sellerName: data.sellerUnitOrIndividual, // '卖方单位/个人',
            sellerNumber: data.sellerUnitCodeOrIdNo, // '卖方单位代码/身份证号码',
            sellerAddress: data.sellerUnitOrIndividualAddress, // '卖方单位/个人住址',
            sellerPhone: data.sellerPhone, // 卖方电话,
            licenseTag: data.licensePlate, // 车牌照号,
            registrationNo: data.registrationNo, // '登记证号',
            vehicleType: data.vehicleType, // '车辆类型',
            vinNo: data.vehicleNo, // '车架号/车辆识别代码',
            brandAndModel: data.factoryModel, // '厂牌型号',
            managementOfficeName: data.transferredVehicleOffice, // '转入地车辆 管理所名称',
            totalCap: data.carPrice ? Field.toStringChinese(data.carPrice) : '', // '车价合计（大写）',
            totalLet: data.carPrice, // '车价合计（小写）',
            auctionUnit: '', // '经营、拍卖单位',
            auctionUnitAddress: '',// '经营、拍卖单位地址'
            auctionUnitTaxNumber: '', // '经营、拍卖单位税号',
            auctionUnitBankNumber: '', // '经营、拍卖单位开户银行、账号',
            auctionUnitPhone: '', // '经营、拍卖单位电话',
            usedCarMarketName: data.lemonMarket, // '二手车市场',
            usedCarMarketTaxNumber: data.lemonMarketTaxNo, // '二手车市场税号',
            usedCarMarketAddress: data.lemonMarketAddress, // 二手车市场地址,
            usedCarMarketBankNumber: data.lemonMarketBankAndAccount, // '二手车市场开户银行、账号',
            usedCarMarketPhone: data.lemonMarketPhone, // '二手车市场电话',
            mark: data.remark,// '备注：',
            invoiceOffice: '', // '开票单位',
            toExamine: '', // '工商部门审核',
            drawer: data.payee // '开票人',
        };
    }
    rollContentData = (data) => {
        return {
            machineNum: data.invoiceNumber, // 机打号码
            machineNumber: data.machineCode, // 机器编号
            sellerName: data.supplierName, // 销售方名称
            sellerNs: data.supplierTaxId, // 销方纳税人识别号
            invoiceDate: data.invoiceDate ? moment.unix(data.invoiceDate / 1000)
                .format('YYYY-MM-DD') : '', // 开票日期
            drawer: data.payee, // 收款员
            buyerName: data.buyerName, // 购买方名称
            buyerNs: data.buyerTaxId, // 购方纳税人识别号
        };
    }
    rollContentDataTitle = () => {
        return {
            machineNum: '机打号码',
            machineNumber: '机器编号',
            sellerName: '销售方名称',
            sellerNs: '销方纳税人识别号',
            invoiceDate: '开票日期',
            drawer: '收款员',
            buyerName: '购买方名称',
            buyerNs: '购方纳税人识别号',
        };
    }
    rollTypeInvoiceData = (data) => {
        return {
            typeText: getCityName(data.invoiceCode || '') + '增值税普通发票(卷票)',  // '北京增值税普通发票(卷票)'
            invoiceCode: data.invoiceCode,
            invoiceNum: data.invoiceNumber
        };
    }
    rollInvoiceDataColumns = () => {
        return [
            {
                title: '发票代码：',
                dataIndex: 'invoiceCode',
                render: (text) => {
                    return text;
                }
            },
            {
                title: '发票号码：',
                dataIndex: 'invoiceNum',
                // alignText: 'center' as ('center' | 'flex-end' | 'flex-start'),
                render: (text) => {
                    return text;
                }
            }
        ];
    }
    rollTotalData = (data) => {
        return {
            totalNum: data.amount,
            totalC: Field.toStringChinese(data.amount),
            checkCode: data.invoiceParityCode
        };
    }
    rollTotalTitle = () => {
        return {
            totalNum: '合计金额(小写)',
            totalC: '合计金额(大写)',
            checkCode: '校验码'
        };
    }
    rollGoodsColumns = () => {
        return [
            {
                title: '项目',
                dataIndex: 'name',
                width: 178,
                alignText: 'center' as ('center' | 'left' | 'right'),
                render: (text) => {
                    return (
                        <Tooltip title={text} placement="topLeft">
                            <div 
                                style={{maxWidth: '170px', whiteSpace: 'nowrap', overflow: "hidden", textOverflow: "ellipsis"}}
                            >
                                {text}
                            </div>
                        </Tooltip>
                    );
                }
            },
            {
                title: '数量',
                dataIndex: 'quantity',
                width: 79,
                alignText: 'left' as ('center' | 'left' | 'right'),
                render: (text, record, index) => {
                    return text;
                }
            },
            {
                title: '单价',
                dataIndex: 'unitPrice',
                width: 89,
                alignText: 'right' as ('center' | 'left' | 'right'),
                render: (text, record, index) => {
                    return text;
                }
            },
            {
                title: '金额',
                dataIndex: 'taxDetailAmount',
                alignText: 'right' as ('center' | 'left' | 'right'),
                render: (text, record, index) => {
                    return text;
                }
            },
        ];
    }
    renderPlate = () => {
        let invoiceType = this.props.templateType;
        let invoiceData = this.props.templateData;
        if (invoiceType === 'VAT_INVOICE_USED_CAR') { // 二手车
            return (
                <Modal
                    visible={this.props.template}
                    width="1280px"
                    footer={null}
                    onCancel={this.props.closeTemplate}
                >
                    <UsedCarInvoicePlate
                        usedCarInvoiceData={this.usedCarInvoiceData(invoiceData)}
                        usedCarInvoiceDataColumns={this.usedCarInvoiceDataColumns()}
                        contentData={this.usedCarContentData(invoiceData)}
                    />
                </Modal>
            );
        } else if (invoiceType === 'VAT_INVOICE_VOLUME') { // 卷票
            return (
                <Modal
                    visible={this.props.template}
                    width="650px"
                    footer={null}
                    onCancel={this.props.closeTemplate}
                >
                    <RollTypeInvoicePlate
                        contentData={this.rollContentData(invoiceData)}
                        contentDataTitle={this.rollContentDataTitle()}
                        invoiceData={this.rollTypeInvoiceData(invoiceData)}
                        invoiceDataColumns={this.rollInvoiceDataColumns()}
                        goodsColumns={this.rollGoodsColumns()}
                        goodsData={invoiceData.saleItemList || []}
                        rollTotalData={this.rollTotalData(invoiceData)}
                        rollTotalTitle={this.rollTotalTitle()}
                        isVirtualized={true}
                    />
                </Modal>
            );
        } else {
            return Template({ type: invoiceType, data: invoiceData, onClose: this.props.closeTemplate });
        }
    }


    render() {
        return (
            <div>
                {
                    this.renderPlate()
                }
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceInput/UI.InvoiceModal.tsx